<div class="container" *transloco="let t; read: TRANSLATION_SCOPE">
  <rx-button
    buttonClass="link mt-4 mb-2 no-text-decoration"    
    (click)="routerFacade.navigateBack()"
    icon="rx-left"
    iconPosition="left"
    [text]="t('back')"
  >
  </rx-button>
  <rx-applications-temporary-approver-page />
</div>
